// extracted by mini-css-extract-plugin
module.exports = {"off-grid-A":"A_off-grid-A__QNgTm"};